import { create } from 'zustand'

const useInovationStore = create((set) => ({
  product_innovation: [
    { isLoading: true },
    { isLoading: true },
    { isLoading: true },
  ],
  service_innovation: [
    { isLoading: true },
    { isLoading: true },
    { isLoading: true },
  ],
  business_model: [
    { isLoading: true },
    { isLoading: true },
    { isLoading: true },
  ],
  infra_develop: [
    { isLoading: true },
    { isLoading: true },
    { isLoading: true },
  ],
  tab_list: ['產品創新', '服務創新', '商業模式', '環境建設'],
  setField: (field, value) => set((state) => ({ ...state, [field]: value })),
  init: () =>
    set((state) => ({
      ...state,
      product_innovation: [
        { isLoading: true },
        { isLoading: true },
        { isLoading: true },
      ],
      service_innovation: [
        { isLoading: true },
        { isLoading: true },
        { isLoading: true },
      ],
      business_model: [
        { isLoading: true },
        { isLoading: true },
        { isLoading: true },
      ],
      infra_develop: [
        { isLoading: true },
        { isLoading: true },
        { isLoading: true },
      ],
    })),
}))

export default useInovationStore
